<template>
  <v-container id="group-contacts" fluid tag="section">
    <div class="tabSwitcher">
      <div class="tabSwitcherInnerWRapper">
        <div
          :class="activeTab === 'manage-static-groups' ? 'tab selected' : 'tab'"
          @click="_switchTab('manage-static-groups')"
        >
          EHR Groups
        </div>
        <div
          :class="activeTab === 'manage-dynamic-groups' ? 'tab selected' : 'tab'"
          @click="_switchTab('manage-dynamic-groups')"
        >
          EHR Dynamic Groups
        </div>
      </div>
    </div>

    <manage-dynamic-groups v-if="activeTab === 'manage-dynamic-groups'" />
    <manage-static-groups v-if="activeTab === 'manage-static-groups'" />
  </v-container>
</template>

<script>
  /* eslint-disable */
export default {
  components: {
    ManageDynamicGroups: () => import("../../components/manage-dynamic-groups/manage-dynamic-groups.vue"),
    ManageStaticGroups: () => import("../../components/manage-static-groups/manage-static-groups.vue")
  },

  props: {
    activeTab: {
      required: false,
      type: String,
      default: "manage-dynamic-groups"
    }
  },

  data: {},

  computed: {},

  watch: {},

  created() {},

  methods: {
    _switchTab(tab) {
      this.$router.push({
        name: "Manage Groups",
        params: { activeTab: tab }
      });
    }
  }
};
</script>

<style lang="scss">
.tabSwitcher {
  width: 100%;
  display: flex;
  margin-bottom: 3rem;
  justify-content: center;
  align-items: center;
  .tabSwitcherInnerWRapper {
    padding: 5px 8px;
    border: 1px solid #00a65f;
    border-radius: 25px;
    display: flex;
    .tab {
      padding: 10px 45px;
      font-size: 14px;
      cursor: pointer;
      color: #00a65f;
      font-weight: 600;
      &.selected {
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
        color: white;
        background-color: #00a65f;
        cursor: unset;
        border-radius: 25px;
      }
    }
  }
}
</style>
